import React, { useEffect, useState } from 'react'
import cardImg from './images/icons/credit-card.png'
import walletsImg from './images/icons/wallet.png'
import duepayImg from './images/icons/time-is-money.png'
import otherImg from './images/icons/coin.png'
import summary from './images/icons/contract.png'
import remove from './images/icons/remove.png'

function PartPay({onClose , billNo , amount , prevPayments , customerPhone , updated , setSelectedPaymentFunc}) {

    const [payment,setPayment] = useState('card')

    // console.log('payment',payment);

    const handleClickPay = (field) =>{
        setPayment(field)
    }

    const [partPayments,setPartPayments] = useState({'cash' : amount})

    const [partPaymentAmounts,setPartPaymentAmounts] = useState({})

    // console.log('partPayments',partPayments);

    useEffect(() => {
        if (Object.keys(partPayments).length > 1) {
            updated(partPayments)
        }
    },[partPayments])

    useEffect(() => {
        if (prevPayments) {
            setPartPayments(prevPayments)
            setPartPaymentAmounts(prevPayments)
        }
    },[prevPayments])

    const handlePartPayments = () => {
        if (partPaymentAmounts[payment] && partPaymentAmounts[payment] !== '') {
            const totalPaid = Object.entries(partPayments)
                .filter(([key]) => key !== "cash" && key !== payment) // Exclude cash from calculation
                .reduce((sum, [, val]) => sum + (parseInt(val) || 0), 0) 
                + parseInt(partPaymentAmounts[payment]);
    
            const cashAmount = amount - totalPaid; // Calculate remaining balance
    
            setPartPayments(prev => ({
                ...prev,
                [payment]: parseInt(partPaymentAmounts[payment]), 
                cash: cashAmount
            }));
        } else {
            console.log("hiiiii",partPayments[payment]);
            
            // setPartPayments(prev => ({
            //     ...prev,
            //     [payment] : ''
            // }))
            setPartPayments(prev => ({
                ...prev,
                cash: (prev.cash || 0) + (parseInt(partPayments[payment]) || 0), // Add the removed payment amount to cash
                [payment]: '' // Set the removed payment to an empty string
            }));
            setPartPaymentAmounts(prev => ({
                ...prev,
                [payment] : ''
            }))
        }
        setPayment('')
    }

    const handleOnChange = (e) => {
        let val = parseInt(e.target.value) || 0;
    
        // Determine the max limit based on whether payment exists in partPayments
        const maxLimit = partPayments[payment] 
            ? partPayments[payment] + partPayments.cash 
            : partPayments.cash;
    
        // Ensure val does not exceed maxLimit
        if (val > maxLimit) {
            val = maxLimit;
        }
    
        setPartPaymentAmounts(prev => ({
            ...prev,
            [payment]: val
        }));
    };    

    const handleRemove = (field) => {
        setPartPayments(prev => {
            const updatedPayments = { ...prev, [field]: '' };
    
            // Calculate new cash amount after removal
            const totalPaid = Object.entries(updatedPayments)
                .filter(([key]) => key !== "cash" && key !== field) // Exclude 'cash' and the removed payment
                .reduce((sum, [, val]) => sum + (parseInt(val) || 0), 0);
    
            return {
                ...updatedPayments,
                cash: amount - totalPaid // Update cash with the new balance
            };
        });
    
        setPartPaymentAmounts(prev => ({
            ...prev,
            [field]: ''
        }));
    };
    
    
  return (
    <div className='absolute inset-0 w-fulll h-full bg-[#fff] flex flex-col p-3 gap-3 font-nunito overflow-auto customScroll'>
        <div className='w-full flex py-2 border-b border-[#cccccc] font-semibold'>
            <span>Part Payment</span>
        </div>
        <div className='w-full flex text-[#424242]'>
            <div className='w-1/2 flex justify-start items-center'>
                <span>Bill No : <span>{billNo}</span></span>
            </div>
            <div className='w-1/2 flex justify-end items-center'>
                <span>Payable Amount : ₹ {amount}</span>
            </div>
        </div>
        <div className='w-full flex flex-col border-[1px] border-[#cccccc] rounded-md'>
            <div className='w-full flex border-b border-[#cccccc] text-[.85rem]'>
                <div className={`flex flex-col px-4 py-2 border-r border-[#cccccc] gap-1 rounded-tl-md cursor-pointer ${payment === 'card' ? 'bg-[#0008B4]' : ''}`} onClick={() => handleClickPay('card')}>
                    <div className='flex justify-center items-center'>
                        <img className={`w-[1.35rem] ${payment === 'card' ? 'invert' : ''}`} src={cardImg} alt="" />
                    </div>
                    <span className={`${payment === 'card' ? 'text-[#fff]' : ''}`}>Card</span>
                </div>
                <div className={`flex flex-col px-4 py-2 border-r border-[#cccccc] gap-1 cursor-pointer ${payment === 'wallets' ? 'bg-[#0008B4]' : ''}`} onClick={() => handleClickPay('wallets')}>
                    <div className='flex justify-center items-center'>
                        <img className={`w-[1.35rem] ${payment === 'wallets' ? 'invert' : ''}`} src={walletsImg} alt="" />
                    </div>
                    <span className={`${payment === 'wallets' ? 'text-[#fff]' : ''}`}>Wallets</span>
                </div>
                <div className={`flex flex-col px-4 py-2 border-r border-[#cccccc] gap-1 cursor-pointer ${payment === 'other' ? 'bg-[#0008B4]' : ''}`} onClick={() => handleClickPay('other')}>
                    <div className='flex justify-center items-center'>
                        <img className={`w-[1.35rem] ${payment === 'other' ? 'invert' : ''}`} src={otherImg} alt="" />
                    </div>
                    <span className={`${payment === 'other' ? 'text-[#fff]' : ''}`}>Other</span>
                </div>
                <div className={`flex flex-col px-4 py-2 border-r border-[#cccccc] gap-1 cursor-pointer ${payment === 'duepayment' ? 'bg-[#0008B4]' : ''}`} onClick={() => handleClickPay('duepayment')}>
                    <div className='flex justify-center items-center'>
                        <img className={`w-[1.35rem] ${payment === 'duepayment' ? 'invert' : ''}`} src={duepayImg} alt="" />
                    </div>
                    <span className={`${payment === 'duepayment' ? 'text-[#fff]' : ''}`}>Due Payment</span>
                </div>
            </div>
            {payment === 'wallets' && (
                <div></div>
            )}
            {payment === 'other' && (
                <div className='w-full flex p-3 gap-3 border-b-[1px] border-[#cccccc]'>
                    <div className='flex flex-col gap-1'>
                        <span>Other:</span>
                        <input type="text" className='border-[1px] rounded-sm p-1'/>
                    </div>
                    <div className='flex flex-col gap-1'>
                        <span>Comments:</span>
                        <input type="text" className='border-[1px] rounded-sm p-1'/>
                    </div>
                </div>
            )}
            {['card', 'wallets', 'other', 'duepayment'].includes(payment) && (
                <div className='w-full flex flex-col p-3 gap-3'>
                    <span className='font-semibold'>Captured Amount:</span>
                    <div className='w-full flex gap-2 justify-start items-center'>
                        {payment === 'duepayment' && (
                            <div className='w-max flex gap-2 justify-start items-center'>
                                <span>Customer Phone:</span>
                                <input type="number" className='border-[1px] rounded-sm p-1 text-left'
                                value={customerPhone || ''}
                                // onChange={handleOnChange}
                                disabled
                                />
                            </div>
                        )}
                        <div className='w-max flex gap-2 justify-start items-center'>
                            <span>Enter Amount:</span>
                            <input type="number" className='border-[1px] rounded-sm p-1'
                            value={partPaymentAmounts[payment] || ''}
                            onChange={handleOnChange}/>
                            <button className='bg-[#0008B4] text-[#fff] py-1 px-3 rounded-sm' onClick={handlePartPayments}>Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
        <div className='w-full flex flex-col border-[1px] border-[#cccccc] rounded-md bg-[#ffe0a5] text-nowrap'>
            <div className='w-full flex p-2 border-b-[1px] border-[#cccccc]'>
                <div className='w-full flex justify-start items-center gap-2'>
                    <div className='flex justify-center items-center'>
                        <img className='w-[1rem]' src={summary} alt="" />
                    </div>
                    <span>Payment Summary</span>
                </div>
                <div className='w-max flex justify-end items-center'>
                    <span>₹ {amount}</span>
                </div>
            </div>
            <div className='w-full flex flex-col px-2'>
                {partPayments.card && (
                    <div className='w-full flex py-2 border-b-[1px] border-[#d3d3d3]'>
                        <div className='w-full flex justify-start items-center gap-2'>
                            <div className='flex justify-center items-center bg-[#c30000] p-[.1rem] rounded-full cursor-pointer' onClick={() => handleRemove('card')}>
                                <img className='w-[1rem] invert' src={remove} alt="" />
                            </div>
                            <span>Pay via Card</span>
                        </div>
                        <div className='w-max flex justify-end items-center'>
                            <span>₹ {partPayments.card}</span>
                        </div>
                    </div>
                )}
                {partPayments.wallets && (
                    <div className='w-full flex py-2 border-b-[1px] border-[#d3d3d3]'>
                        <div className='w-full flex justify-start items-center gap-2'>
                            <div className='flex justify-center items-center bg-[#c30000] p-[.1rem] rounded-full cursor-pointer' onClick={() => handleRemove('wallets')}>
                                <img className='w-[1rem] invert' src={remove} alt="" />
                            </div>
                            <span>Pay via Wallet</span>
                        </div>
                        <div className='w-max flex justify-end items-center'>
                            <span>₹ {partPayments.wallets}</span>
                        </div>
                    </div>
                )}
                {partPayments.other && (
                    <div className='w-full flex py-2 border-b-[1px] border-[#d3d3d3]'>
                        <div className='w-full flex justify-start items-center gap-2'>
                            <div className='flex justify-center items-center bg-[#c30000] p-[.1rem] rounded-full cursor-pointer' onClick={() => handleRemove('other')}>
                                <img className='w-[1rem] invert' src={remove} alt="" />
                            </div>
                            <span>Pay via Other</span>
                        </div>
                        <div className='w-max flex justify-end items-center'>
                            <span>₹ {partPayments.other}</span>
                        </div>
                    </div>
                )}
                {partPayments.duepayment && (
                    <div className='w-full flex py-2 border-b-[1px] border-[#d3d3d3]'>
                        <div className='w-full flex justify-start items-center gap-2'>
                            <div className='flex justify-center items-center bg-[#c30000] p-[.1rem] rounded-full cursor-pointer' onClick={() => handleRemove('duepayment')}>
                                <img className='w-[1rem] invert' src={remove} alt="" />
                            </div>
                            <span>Due payment - {customerPhone}</span>
                        </div>
                        <div className='w-max flex justify-end items-center'>
                            <span>₹ {partPayments.duepayment}</span>
                        </div>
                    </div>
                )}
                {partPayments.cash > 0 && (
                    <div className='w-full flex py-2'>
                        <div className='w-full flex justify-start items-center gap-2'>
                            <div className='flex justify-center items-center bg-[#c30000] p-[.1rem] rounded-full opacity-0'>
                                <img className='w-[1rem] invert' src={remove} alt="" />
                            </div>
                            <span>Pay via Cash</span>
                        </div>
                        <div className='w-max flex justify-end items-center'>
                            <span>₹ {partPayments.cash}</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
        <div className='w-full flex justify-end items-center'>
            <button className='border-[1.5px] rounded-sm border-[#7b7b7b] text-[1rem] p-2' onClick={() => {
                onClose(false)
                if (partPayments.cash === amount) {
                    setSelectedPaymentFunc('',false)
                    updated(null) 
                }
            }}>Back To KOT</button>
        </div>
    </div>
  )
}

export default PartPay
